import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import lodash from 'lodash';
import AccessControl from 'components/AccessControl';
import { access } from 'constants/index';
import { ButtonsSubmitExport } from 'ui';
import { PublisherSelectSSA, SiteSelectSSA, TextInput } from 'ui-blocks/form-elements';
import authUtil from 'util/auth';
import { createSyndicatedAdChannel } from '../../../services/servicesSyndicatedSpondoredAds';
import FieldItem from '../FieldItem';

const appAdminAccess = access.getAdminAccessByApp.syndicatedSponsoredAds;

const getIdName = (obj) => ({
   id: obj?.id,
   name: obj?.name,
});


const CreateChannelModal = (props) => {
   const userPartnerRoleList = useSelector(
      (state) => (state?.authReducer?.loggedInUserPartner?.roles || []),
      shallowEqual,
   );

   const [validationSchema, setValidationSchema] = useState(undefined);

   useEffect(() => {
      const innerValidationSchema = {
         site: Yup.object().required('Required!'),
         name: Yup.string().required(),
      };

      if (authUtil.hasAuthAccess(appAdminAccess)) {
         innerValidationSchema.publisher = Yup.object().required('Required!');
      }
      setValidationSchema(Yup.object().shape(innerValidationSchema));
   }, [userPartnerRoleList]);

   return (
      <Formik
         initialValues={{
            publisher: undefined,
            site: undefined,
         }}
         validationSchema={validationSchema}
         validateOnChange={ false }
         validateOnBlur={ false }
         onSubmit={ (values, { setSubmitting, setErrors }) => {
            const payload = {
               site: getIdName(values?.site),
               name: values?.name,
            };

            if (authUtil.hasAuthAccess(appAdminAccess)) {
               payload.publisher = getIdName(values?.publisher);
            }

            createSyndicatedAdChannel(payload).then((res) => {
               const { status, error } = res?.data;
               if (status === 'success') {
                  toastr.success('Channel successfully created!');
                  props.close(200);
               } else if (lodash.isPlainObject(error) && Object.keys(error).length > 0) {
                  setSubmitting(false);
                  setErrors(error);
               } else {
                  setSubmitting(false);
                  toastr.error('An error occurred. Please try again later.');
               }
            });
         }}
      >
         {
            (formik) => {
               return (
                  <Modal
                     isOpen={props.isOpen}
                     toggle={props.toggle}
                     backdrop='static'
                     keyboard={ false }
                     fade={false}
                  >
                     <ModalHeader
                        toggle={props.toggle}
                     >
                        Create Channel
                     </ModalHeader>
                     <ModalBody>
                        <Form className='container'>
                           <AccessControl
                              access={appAdminAccess}
                           >
                              <FieldItem
                                 label='Publisher'
                                 name='publisher'
                                 component={PublisherSelectSSA}
                                 isSearchable
                                 onChange={() => {
                                    formik.setFieldValue('site', undefined, false);
                                    formik.setFieldTouched('site', false, false);
                                 }}
                              />
                           </AccessControl>
                           <FieldItem
                              label='Site'
                              name='site'
                              component={SiteSelectSSA}
                              suggestionDependencies={{
                                 publisher: formik?.values?.publisher,
                              }}
                              isSearchable
                           />
                           <FieldItem
                              label='Channel Name'
                              name='name'
                              component={TextInput}
                              isSearchable
                           />
                        </Form>
                     </ModalBody>
                     <ModalFooter className='d-flex justify-content-center'>
                        <ButtonsSubmitExport
                           handleSubmit={formik.handleSubmit}
                        />
                     </ModalFooter>
                  </Modal>
               );
            }
         }
      </Formik>
   );
};

CreateChannelModal.propTypes = {
   toggle: PropTypes.func.isRequired,
   isOpen: PropTypes.bool.isRequired,
   close: PropTypes.func.isRequired,
};

export default CreateChannelModal;
